import generateGuid from 'uuid/v4';
import q from 'q';

export var JSON_CONTENT_TYPE = 'application/json';

export default ['$rootScope', '$http', '$q', 'JsonRPCService', 'ModalService', function ($rootScope, $http, $q, JsonRPCService, ModalService) {
    return {
        getMsfPortalHost: function getMsfPortalHost(endpoint, method) {
            var currentLocale = null;
            var portalLanguageVariant = '';
            var headers = angular.copy(baseHeaders);
            if (currentLocale) {
                headers['Accept-Language'] = '' + currentLocale + portalLanguageVariant;
            }
            var requestCode = generateGuid();
            var baseHeaders = {
                'Accept': JSON_CONTENT_TYPE,
                'Content-Type': JSON_CONTENT_TYPE
            };
            headers = Object.assign(baseHeaders, headers);

            console.log('getting into getMsfPortalHost function on ==> endpoint is ' + endpoint);

            var params = null;
            return fetch(endpoint, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    'id': '' + requestCode,
                    'jsonrpc': '2.0',
                    method: method,
                    params: params
                })
            }).then(function (res) {
                if (!res.ok) {
                    // Fix for Defect 0455 to show Portal down message when PC is down.
                    if (res.status >= 500 && res.status < 505) {
                        $rootScope.appDn = true;
                        ModalService.showError('', 'PortalDown.Message').result.then(function () {
                            window.location.hash = '#/auth/login';
                        });
                    }
                    return res.json().then(function (data) {
                        console.log('Error from msfpathlookupservice ===>' + data.error);
                        return data.error;
                    });
                }
                return res.json().then(function (data) {
                    // all is well ...revert root scope value to false
                    $rootScope.appDn = false;
                    console.log(data.result);
                    return data.result;
                });
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/msfpathlookup/service/MsfPathLookupService.js
// module id = 1875
// module chunks = 0